import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { formatTimespent, formatName } from "../../../../services/report.service";

import { Col, Row } from 'react-bootstrap';

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import DefaultAssetIcon from '../../../../images/defaultAsset.jpg';
import numeral from 'numeral';
import Truncate from 'src/components/truncate';
import { localizedStrings } from "../../../../../localization/index"
import Tooltip from 'src/components/tooltip';


class DealGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    var asset = _.get(this.props.item, 'asset');

    return (
      <Row className={cx(styles.row, entityStyles.deal)}>
        <Col className={cx(styles.column, entityStyles.name)} md={3}>{_.get(this.props.item, 'name')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>{dateformat(this.props.item.createdDate, 'dd mmm yyyy')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>USD {this.props.item.amount}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}><Truncate width={80} >{this.props.item.stage}</Truncate></Col>
        <Col className={cx(styles.column)} md={3}>
          {asset ?
            <a href={`/assets/${asset.id}`} target='_blank' className={cx(styles.item, entityStyles.asset)}>
              <img className={styles.icon} src={_.get(asset, 'icon.thumbnail') || DefaultAssetIcon} />
              <div>

                <Tooltip content={_.get(asset, 'name')} placement="bottom">
                  <Truncate data-for="author-name" data-tip={_.get(asset, 'name')} width={100} >
                    {_.get(asset, 'name')}
                  </Truncate>
                </Tooltip>

                {asset.count > 1 &&
                  <div>&amp; {asset.count - 1} {this.localizedTabsCommons.assets}</div>
                }
              </div>
            </a>
            : "--/--"}
        </Col>
      </Row>
    );
  }
}

const Deal = {};
Deal.Grid = DealGridItem;

export default Deal;